import React from "react";
import {FormattedMessage} from "react-intl";
import "../styles/MapPageView.css";

export function LoadingMessage() {
    return (
        <div className="message">
            <FormattedMessage id="loading" />
        </div>
    );
}
